(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-catalogue-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-catalogue')) {
    let catalogueId = 0;
    customElements.define('product-catalogue', class extends HTMLElement {
      connectedCallback() {
        if (this.trigger) return;
        this.trigger = this.querySelector('[data-catalogue-open]');
        this.onOpen = (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
          if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
          event.preventDefault();
          if (!this.dialog) this.createDialog();
          if (this.dialog.open) return;
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          this.openReader();
        };
        this.trigger.addEventListener('click', this.onOpen);
      }
      createDialog() {
        this.dialog = this.querySelector('template').content.querySelector('dialog').cloneNode(true);
        const id = `product-catalogue-${++catalogueId}`;
        this.dialog.id = id;
        this.dialog.querySelector('h2').id = `${id}-title`;
        this.dialog.setAttribute('aria-labelledby', `${id}-title`);
        this.trigger.setAttribute('aria-controls', id);
        this.dialog.querySelector('[data-catalogue-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow;
          this.reader?.pause();
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        });
        document.body.appendChild(this.dialog);
      }
      async openReader() {
        if (this.reader) { this.reader.resume(); return; }
        if (this.loadingReader) return;
        this.loadingReader = true;
        const viewer = this.dialog.querySelector('[data-pdf-url]');
        try {
          const module = await import(this.dataset.readerSrc);
          if (!this.isConnected) return;
          this.reader = new module.CatalogueReader(viewer);
          await this.reader.open();
          if (!this.dialog.open) this.reader.pause();
        } catch (error) {
          viewer.querySelector('[role="status"]').textContent = viewer.dataset.error;
        } finally { this.loadingReader = false; }
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow;
        }
        this.reader?.destroy();
        this.reader = null;
        this.dialog?.remove();
        this.dialog = null;
        this.trigger?.removeEventListener('click', this.onOpen);
        this.trigger = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
